import { asNumber, asString, isObject } from "./model-utils";

export class AddressInfo {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.address = asString(json.address);
    this.city = asString(json.city);
    this.state = asString(json.state);
    this.country = asString(json.country);
    this.countryCode = asString(json.countryCode);
    this.postalCode = asString(json.postalCode);
    this.latitude = asNumber(json.latitude);
    this.longitude = asNumber(json.longitude);
  }

  static fromJson(json: any) {
    return isObject(json) ? new AddressInfo(json) : json;
  }
}
